
    import __i18nConfig from '@next-translate-root/i18n.json'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import type { GetStaticProps } from 'next';
import AlternativesHub from '@/components/agents/alternatives/AlternativesHub';
import { getAlternativesHubProps } from '@/components/agents/alternatives/server';
import type { AlternativesHubProps } from '@/components/agents/alternatives/types';
export default function AgentAlternatives(props: AlternativesHubProps) {
    return <AlternativesHub {...props}/>;
}
// English only: other languages redirect here (next.config.mjs).
const getStaticProps: GetStaticProps<AlternativesHubProps> = async ({ locale, }) => {
    if (locale && locale !== 'en')
        return { notFound: true };
    return { props: await getAlternativesHubProps(), revalidate: 3600 };
};

    async function __Next_Translate__getStaticProps__1a15d8fc257__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/alternatives/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../../../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a15d8fc257__ as getStaticProps }
  